import { createActionTypes } from '../../state/actions'

export const FETCH_KEYWORD_LISTS = createActionTypes('FETCH_KEYWORD_LISTS')
export const fetchKeywordLists = () => ({
  type: FETCH_KEYWORD_LISTS.action,
})
export const fetchKeywordListsSuccess = (payload) => ({
  type: FETCH_KEYWORD_LISTS.success,
  payload,
})
export const fetchKeywordListsFailed = (error) => ({
  type: FETCH_KEYWORD_LISTS.failed,
  error,
})

export const ADD_KEYWORD_LIST = createActionTypes('ADD_KEYWORD_LIST')
export const addKeywordList = (name, onComplete) => ({
  type: ADD_KEYWORD_LIST.action,
  name,
  onComplete,
})
export const addKeywordListSuccess = (payload) => ({
  type: ADD_KEYWORD_LIST.success,
  payload,
})

export const DELETE_KEYWORD_LIST = createActionTypes('DELETE_KEYWORD_LIST')
export const deleteKeywordList = (id, onComplete) => ({
  type: DELETE_KEYWORD_LIST.action,
  id,
  onComplete,
})
export const deleteKeywordListSuccess = (payload) => ({
  type: DELETE_KEYWORD_LIST.success,
  payload,
})

export const UPDATE_KEYWORD_LIST = createActionTypes('UPDATE_KEYWORD_LIST')
export const updateKeywordList = (id, payload, onComplete) => ({
  type: UPDATE_KEYWORD_LIST.action,
  id,
  payload,
  onComplete,
})

export const UPDATE_KEYWORD_LISTS = createActionTypes('UPDATE_KEYWORD_LISTS')

export const updateKeywordLists = (lists, payload, onComplete) => ({
  type: UPDATE_KEYWORD_LISTS.action,
  lists,
  payload,
  onComplete,
})

export const updateKeywordListSuccess = (payload) => ({
  type: UPDATE_KEYWORD_LIST.success,
  payload,
})

export const GET_KEYWORD_LIST_DATA = createActionTypes('GET_KEYWORD_LIST_DATA')
export const getKeywordListData = (id, onComplete) => ({
  type: GET_KEYWORD_LIST_DATA.action,
  id,
  onComplete,
})
export const getKeywordListDataSuccess = (payload) => ({
  type: GET_KEYWORD_LIST_DATA.success,
  payload,
})

export const CHANGE_SORT = createActionTypes('CHANGE_SORT')
export const changeSort = (sort, handleNumeric) => ({
  type: CHANGE_SORT.action,
  sort,
  handleNumeric,
})

export const GET_KEYWORD_LOCATIONS = createActionTypes('GET_KEYWORD_LOCATIONS')

export const getKeywordLocations = () => ({
  type: GET_KEYWORD_LOCATIONS.action,
})

export const getKeywordLocationsSuccess = (payload) => ({
  type: GET_KEYWORD_LOCATIONS.success,
  payload,
})
